<template>
  <div
    v-if="showAccountButtonInfo"
    class="account-button-container wrn-p-x-lg-1"
  >
    <Row :has-line="false">
      <div v-if="avatarImageURL" slot="icon-left">
        <img
          class="avatar-image"
          height="44"
          width="44"
          :src="avatarImageURL"
          alt="advisor_brand_avatar"
        />
      </div>
      <RoundedIcon
        v-if="iconName"
        slot="icon-left"
        background-size="44"
        :icon-name="iconName"
        :main-color="NebraskaColors.elementPrimary"
      />
      <RoundedIcon
        v-if="iconLetter"
        slot="icon-left"
        background-size="44"
        :text="iconLetter"
        :icon-name="avatarImageURL"
        :text-color="NebraskaColors.textNegative"
        :main-color="NebraskaColors.elementPrimary"
      />
      <template #top-left>
        <BaseText as="strong" size="lg">{{ userName }}</BaseText>
      </template>
      <template #bottom-left>
        <BaseText
          v-if="accountDescription"
          size="sm"
          :color="NebraskaColors.textSecondary"
        >
          {{ accountDescription }}
        </BaseText>
      </template>
    </Row>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, Row, RoundedIcon } from '@warrenbrasil/nebraska-web';

@Component({
  components: { RoundedIcon, Row, BaseText }
})
export default class AccountButton extends Vue {
  readonly NebraskaColors = NebraskaColors;

  @Prop({ type: String, required: false })
  public iconLetter!: string;

  @Prop({ type: String, required: false })
  public iconName!: string;

  @Prop({ type: String, required: false })
  public avatarImageURL!: string;

  @Prop({ type: String, required: true })
  public userName!: string;

  @Prop({ type: String, required: false })
  public accountDescription!: string;

  get showAccountButtonInfo() {
    return this.avatarImageURL || this.iconLetter || this.iconName;
  }
}
</script>

<style lang="less" scoped>
.account-button-container {
  box-sizing: border-box;
  border-radius: 10px;
  background-color: @background-secondary;
  border: 2px solid @background-secondary;
}

.avatar-image {
  border-radius: 50%;
  object-fit: cover;
}
</style>
